"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.getOffsetByOriginalIndex = exports.getOffsetBySlideIndex = exports.getNearestSlide = exports.getVisibleIndexes = exports.getSlidesFromItems = exports.getLeftStack = exports.getRightStack = exports.fillOriginIndex = exports.setFlimSize = exports.setItemSize = exports.fillOffset = exports.circularIndex = exports.resizeToFit = void 0;
var defaultItemWidth = 600;
var defaultFlimWidth = 1920;
var defaultFlimHeight = 400;
var clone = function (obj) { return JSON.parse(JSON.stringify(obj)); };
var getStackLength = function (items, isCenter) {
    return items.reduce(function (acc, it, i) {
        return acc + (i === 0 ? (isCenter ? it.width / 2 : it.width) : it.width);
    }, 0);
};
var preserveAspectScale = function (before, after) {
    var scale = after.height / before.height;
    return {
        width: before.width * scale,
        height: before.height * scale
    };
};
var resizeToFit = function (items, width, height) {
    return items.map(function (it, i) {
        it.width = it.width || defaultItemWidth;
        it.height = it.height || defaultFlimHeight;
        var newSize = preserveAspectScale({ width: it.width, height: it.height }, { width: width, height: height });
        return __assign(__assign({}, it), { slideIndex: i, width: Math.round(newSize.width), height: Math.round(newSize.height) });
    });
};
exports.resizeToFit = resizeToFit;
var circularIndex = function (count, current, relative) {
    var circularRelative = relative % count;
    var newIndex = current + circularRelative;
    if (newIndex > 0)
        return newIndex % count;
    if (newIndex < 0)
        return (count + newIndex) % count;
    return newIndex;
};
exports.circularIndex = circularIndex;
var fillOffset = function (items) {
    return items.map(function (it, i) {
        var prevSum = items
            .slice(0, i)
            .map(function (it) { return it.width; })
            .reduce(function (acc, i) {
            return acc + i;
        }, 0);
        var offset = prevSum;
        return __assign(__assign({}, it), { offset: offset });
    });
};
exports.fillOffset = fillOffset;
var setItemSize = function (flim, itemIndex, size) {
    if (size.width)
        flim.items[itemIndex].width = size.width;
    if (size.height)
        flim.items[itemIndex].height = size.height;
    return flim;
};
exports.setItemSize = setItemSize;
var setFlimSize = function (flim, size) {
    if (size.width)
        flim.width = size.width;
    if (size.height)
        flim.height = size.height;
    return flim;
};
exports.setFlimSize = setFlimSize;
var fillOriginIndex = function (items) {
    return items.map(function (it, i) {
        it.originIndex = i;
        return it;
    });
};
exports.fillOriginIndex = fillOriginIndex;
// right stack is longer as teleport only occurs at repeated slides on the right
var getRightStack = function (items, maxDistance, isCenter) {
    var newStack = (0, exports.fillOriginIndex)(clone(items));
    var stackLength = getStackLength(newStack, isCenter);
    var i = 0;
    while (getStackLength(newStack, isCenter) < stackLength + maxDistance) {
        var newItem = clone(newStack[i % newStack.length]);
        newStack.push(newItem);
        i = i + 1;
    }
    return newStack;
};
exports.getRightStack = getRightStack;
var getLeftStack = function (items, maxDistance, isCenter) {
    var newStack = (0, exports.fillOriginIndex)(clone(items)).reverse();
    var visibleLength = isCenter ? maxDistance / 2 - items[0].width / 2 : 0;
    var i = 0;
    while (getStackLength(newStack, isCenter) < visibleLength + maxDistance) {
        var newItem = clone(newStack[i % newStack.length]);
        newStack.push(newItem);
        i = i + 1;
    }
    return newStack.reverse();
};
exports.getLeftStack = getLeftStack;
var getSlidesFromItems = function (width, items, isCenter) {
    if (items.length === 1) {
        var stack = (0, exports.fillOriginIndex)(clone(items));
        stack[0].center = true;
        return stack;
    }
    var rightStack = (0, exports.getRightStack)(items, width, isCenter);
    var leftStack = (0, exports.getLeftStack)(items, width, isCenter);
    rightStack[0].center = true;
    return leftStack.concat(rightStack);
};
exports.getSlidesFromItems = getSlidesFromItems;
var getVisibleIndexes = function (film, delta) {
    var range = [film.offset + delta, film.offset + delta - film.width];
    var lowDistance = 0 - range[0];
    var currentLow = 0;
    var lowIndex = 0;
    while (currentLow < lowDistance) {
        currentLow += film.slideItems[lowIndex].width;
        lowIndex = lowIndex + 1;
    }
    lowIndex = lowIndex > 0 ? lowIndex - 1 : lowIndex;
    var highDistance = 0 - range[1];
    var currentHigh = 0;
    var highIndex = 0;
    while (currentHigh < highDistance) {
        if (highIndex > film.slideItems.length - 1) {
            break;
        }
        currentHigh += film.slideItems[highIndex].width;
        highIndex = highIndex === film.slideItems.length ? 0 : highIndex + 1;
    }
    highIndex = highIndex > 0 ? highIndex - 1 : highIndex;
    return [lowIndex, highIndex];
};
exports.getVisibleIndexes = getVisibleIndexes;
var getNearestSlide = function (slides, delta, width, center) {
    var needle = Math.abs(delta) + (center ? width / 2 : 0);
    var nearestSlideIndex = slides
        .map(function (it) {
        var itemCenterOffset = it.offset + (center ? it.width / 2 : 0);
        return Math.abs(needle - itemCenterOffset);
    })
        .reduce(function (minIndex, it, i, allValues) {
        return it < allValues[minIndex] ? i : minIndex;
    }, 0);
    return nearestSlideIndex;
};
exports.getNearestSlide = getNearestSlide;
var getOffsetBySlideIndex = function (items, flimWidth, flimHeight, slideIndex, isCenter, originalItems) {
    var originIndex = items[slideIndex].originIndex;
    var invisibleLeftLength = 0 -
        items
            .slice(0, slideIndex)
            .map(function (it) { return it.width; })
            .map(function (it) {
            return it;
        })
            .reduce(function (a, b) { return a + b; }, 0);
    var offsetLeft = isCenter
        ? invisibleLeftLength + flimWidth / 2 - items[slideIndex].width / 2
        : invisibleLeftLength;
    return {
        slideIndex: slideIndex,
        originIndex: originIndex,
        width: flimWidth,
        height: flimHeight,
        offset: Math.round(offsetLeft),
        slideItems: items,
        items: originalItems.map(function (it) { return ({
            width: it.width,
            height: it.height
        }); })
    };
};
exports.getOffsetBySlideIndex = getOffsetBySlideIndex;
var getOffsetByOriginalIndex = function (items, flimWidth, flimHeight, originIndex, isCenter, originalItems) {
    var centerIndex = items.findIndex(function (it) { return it.center; });
    var slideIndex = items.slice(centerIndex).findIndex(function (it) { return it.originIndex === originIndex; }) +
        centerIndex;
    return (0, exports.getOffsetBySlideIndex)(items, flimWidth, flimHeight, slideIndex, isCenter, originalItems);
};
exports.getOffsetByOriginalIndex = getOffsetByOriginalIndex;
